export const SIWS_AUTH_METHOD_TYPE = 'Sign in with Solana'
export const SIWS_AUTH_METHOD_ID_PREFIX = 'siws'
